"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Callout.css");

var _styles = {
  "container": "Callout__container___3Rqm0",
  "has-show-more": "Callout__has-show-more___3v9OQ",
  "title": "Callout__title___2kRIk",
  "show-more": "Callout__show-more___QCj2H",
  "expanded": "Callout__expanded___1MUjx",
  "line": "Callout__line___ApcYF",
  "show": "Callout__show___1MTOV",
  "expand-container": "Callout__expand-container___1Gups",
  "not-expand-container": "Callout__not-expand-container___2mEaE",
  "content": "Callout__content___1Tf0G",
  "call-to-action": "Callout__call-to-action___2ZFKc",
  "has-cta": "Callout__has-cta___mYkmc",
  "no-show-more": "Callout__no-show-more___1Q12f",
  "cta-container": "Callout__cta-container___22Kej"
};

const styles = _bind.default.bind(_styles);

const Callout = (0, _mobxReact.observer)(({
  className,
  children,
  title,
  cta,
  hasShowMore,
  showMore,
  showMoreOnClick,
  dataTestId,
  customTitleIcon,
  color = _.Color.neutral._90
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);
  const style = {
    borderLeft: `3px solid ${color}`,
    borderRadius: '4px'
  };

  const renderChildren = () => {
    if (hasShowMore) {
      return _react.default.createElement(_.Expandable, {
        expand: showMore || false,
        className: styles('expand-container')
      }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: styles('content', {
          'has-cta': cta
        }),
        "data-testid": 'callout-children'
      }, children), cta && _react.default.createElement("div", {
        className: styles('call-to-action')
      }, _react.default.createElement("div", {
        className: styles('cta-container')
      }, cta))));
    } else {
      return _react.default.createElement("div", {
        className: styles('not-expand-container')
      }, _react.default.createElement("div", {
        "data-testid": 'callout-children',
        className: styles('content', {
          'has-cta': cta,
          'no-show-more': !hasShowMore
        })
      }, children), cta && _react.default.createElement("div", {
        className: styles('call-to-action')
      }, _react.default.createElement("div", {
        className: styles('cta-container')
      }, cta)));
    }
  };

  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId,
    style: style
  }, _react.default.createElement(_.Content, {
    className: styles({
      'has-show-more': showMore
    }),
    flex: true,
    flexWrap: 'wrap',
    paddingTopBottom: 16,
    paddingLeftRight: 24,
    justifyContent: 'space-between'
  }, _react.default.createElement("div", {
    className: styles('title')
  }, _react.default.createElement(_.Icon, {
    name: customTitleIcon || _.IconEnum.info_circle,
    color: color,
    size: 18
  }), typeof title === 'string' ? _react.default.createElement(_.Text, {
    text: title,
    variant: 'medium'
  }) : title), hasShowMore && showMoreOnClick && _react.default.createElement("div", {
    className: styles('show-more')
  }, _react.default.createElement(_.Button, {
    className: styles('show-button', {
      expanded: showMore
    }),
    dataTestId: 'Callout-show-more',
    label: _react.default.createElement(_react.default.Fragment, null, "Show ", showMore ? 'less' : 'more', ' ', _react.default.createElement(_.Icon, {
      name: _.IconEnum.chevron_down,
      color: _.Color.blue._60
    })),
    variant: 'tertiary',
    onClick: () => showMoreOnClick(!showMore)
  }))), children && renderChildren());
});
var _default = Callout;
exports.default = _default;